import {store} from "@/store"

export const Linker = {
  name: "Linker",
  mounted: (el, binding) => {
    const vm = binding.instance
    if (!vm) return

    const tableInst = vm.$refs["base-table"]
    if (!tableInst) return
    const elementId = tableInst.$.uid
    const id = binding.value.id

    store.dispatch("Linker/actionSetLink", { id, elementId })

    vm.$nextTick(() => {
      if (!tableInst || !tableInst.columns) return

      const columnsIds = tableInst.columns.map(c => c.id)
      store.dispatch("Columns/actionSetColumnsIds", { tableId: elementId, columnsIds })
    })
  },
  updated(el, binding) {
    const comp = binding.instance
    if (!comp) return

    const elementId = comp.$.uid
    const tableInst = comp.$refs["base-table"]
    if (!tableInst) return

    const columnsIds = (tableInst.columns || []).map(c => c.id)
    store.dispatch("Columns/actionUnsetColumns", { tableId: elementId, columnsIds })
  },
}
